import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InnerPageLayout from "../Layout/InnerPageLayout";
import SimpleReactLightbox from "simple-react-lightbox";
import styled from "styled-components";

import {
  Card,
  Col,
  Row,
  Container,
  Button,
  Spinner,
  Carousel,
} from "react-bootstrap";
import { getHRAnnouncements } from "../../api/api";

import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import { Zoom } from "react-slideshow-image";

const HrAnnouncements = () => {
  const [loading, setLoading] = useState(false);
  const { i18n, t } = useTranslation();
  const [index, setIndex] = useState(0);

  interface ProcessedFile {
    id: number;
    title: string;
    fileName: string;
    fileUrl: string;
  }

  interface ProcessedImg {
    id: number;
    title: string;
    fileName: string;
    fileUrl: string;
  }

  // const [selectedCard, setSelectedCard] = useState({Card});
  const [processedFiles, setProcessedFiles] = useState<ProcessedFile[] | null>(
    null
  );

  const [imgFiles, setImgFiles] = useState<ProcessedImg[] | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setProcessedFiles(null);
      setLoading(true);

      //Runs only on the first render
      try {
        const hrFilesResponse = await getHRAnnouncements({
          language: i18n.language,
        });

        const hrFilesList = hrFilesResponse.data
          .filter((item: any) => item.attributes.File.data)
          .map((item: any) => ({
            id: item.id,
            title: item.attributes.Title,
            fileName: item.attributes.File.data.attributes.name,
            fileUrl:
              process.env.REACT_APP_CMS +
              item.attributes.File.data.attributes.url,
          }));
        setProcessedFiles(hrFilesList);

        const hrImgList = hrFilesResponse.data
          .filter((item: any) => item.attributes.Image.data)
          .map((item: any) => ({
            id: item.id,
            title: item.attributes.Title,
            fileName: item.attributes.Image.data.attributes.name,
            fileUrl:
              process.env.REACT_APP_CMS +
              item.attributes.Image.data.attributes.formats.large.url,
          }));
        setImgFiles(hrImgList);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array to run only once

  const handleSelect = (selectedIndex: number) => {
    setIndex(selectedIndex);
  };

  // const indicators = (index) => (<div className="indicator">{index + 1}</div>);

  return (
    <InnerPageLayout>
      {!loading ? (
        <Container>
          <Row>
            <Col>
              <div
                className="responsive-container"
                style={{ maxWidth: "100%", overflow: "hidden" }}
              >
                <Slide
                  // indicators={(index) => <div className="indicator">{0 + 1}</div>}
                  autoplay={false}
                  duration={3000}
                  transitionDuration={500}
                  infinite={false}
                  arrows={true}
                  indicators={false}
                >
                  {imgFiles?.map((file: ProcessedImg, index: number) => (
                    <div className="each-slide-effect">
                      <div
                        style={{
                          backgroundImage: `url(${file.fileUrl ?? ""})`,
                          width: "90%",
                          minHeight: "1000px",
                          margin: "0px auto",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center center",
                        }}
                      >
                        {/* <span>
                          {file.title}
                        </span> */}
                      </div>
                    </div>
                  ))}
                </Slide>
              </div>
            </Col>
          </Row>
          <Row className="mt-5">
                <Col>
                  {processedFiles?.map((file: ProcessedFile, index: number) => (
                    <Row
                      key={index}
                      className="align-items-center file-item mb-3 py-2"
                    >
                      <Col xs={12} md={8} className="d-flex align-items-center">
                        <i
                          className="bi bi-file-earmark-text me-3 text-primary" 
                          style={{ fontSize: "1.2rem" }}
                        ></i>
                        <span className="text-truncate" title={file.title}>
                          {file.title}
                        </span>
                      </Col>
                      <Col xs={12} md={4} className="text-md-end mt-2 mt-md-0">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          href={file.fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t("donwload_file")}
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </Col>
              </Row>
        </Container>
      ) : (
        <Container>
          <Row>
            <Col>
              <center className="mt-4 mb-4">
                <Spinner
                  animation="border"
                  role="status"
                  className="center-spinner"
                >
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </center>
            </Col>
          </Row>
        </Container>
      )}
      {/* <Container>
        <Card
          id={i18n.language === "en" ? "custom-card-en" : "custom-card-ar"}
          className="custom-card right mb-4"
        >
          <Card.Header className="custom-card-header">
            {t("hr_announcements")}
          </Card.Header>
          <Card.Body className="d-flex p-0">
            <Container>
              {loading && (
                <Row>
                  <Col>
                    <center className="mt-4 mb-4">
                      <Spinner
                        animation="border"
                        role="status"
                        className="center-spinner"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </center>
                  </Col>
                </Row>
              )}

              {!loading && (
                <Row>
                  <Col>
                    <SimpleReactLightbox>
                      <StyledContainer>
                        <CarouselWrapper>
                          <StyledCarousel
                            activeIndex={index}
                            onSelect={handleSelect}
                          >
                            {imgFiles?.map(
                              (file: ProcessedImg, index: number) => (
                                <Carousel.Item key={index}>
                                  <img
                                    className="d-inline"
                                    
                                    src={`${file.fileUrl ?? ""}`}
                                    alt={`Slide ${index}`}
                                  />
                                </Carousel.Item>
                              )
                            )}
                          </StyledCarousel>
                          <CarouselIndicatorsWrapper>
                            {imgFiles?.map(
                              (file: ProcessedImg, index: number) => (
                                <ThumbnailButton
                                  key={index}
                                  style={{
                                    backgroundImage: `url(${file.fileUrl})`,
                                  }}
                                  className={index === index ? "active" : ""}
                                  onClick={() => setIndex(index)}
                                />
                              )
                            )}
                          </CarouselIndicatorsWrapper>
                        </CarouselWrapper>
                      </StyledContainer>
                    </SimpleReactLightbox>
                  </Col>
                </Row>
              )}

              <Row>
                <Col>
                  {processedFiles?.map((file: ProcessedFile, index: number) => (
                    <Row
                      key={index}
                      className="align-items-center file-item mb-3 py-2"
                    >
                      <Col xs={12} md={8} className="d-flex align-items-center">
                        <i
                          className="bi bi-file-earmark-text me-3 text-primary" 
                          style={{ fontSize: "1.2rem" }}
                        ></i>
                        <span className="text-truncate" title={file.title}>
                          {file.title}
                        </span>
                      </Col>
                      <Col xs={12} md={4} className="text-md-end mt-2 mt-md-0">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          href={file.fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t("donwload_file")}
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </Col>
              </Row>
            </Container>
          </Card.Body>
        </Card>
      </Container> */}
    </InnerPageLayout>
  );
};

const StyledContainer = styled(Container)`
  margin: 40px;
`;

const CarouselWrapper = styled.div`
  max-width: 800px;
  margin: auto;
`;

const StyledCarousel = styled(Carousel)`
  .carousel-item img {
    height: 500px;
    object-fit: cover;
  }
`;

const CarouselIndicatorsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const ThumbnailButton = styled.button`
  background-size: cover;
  border: none;
  width: 100px;
  height: 60px;
  margin: 0 5px;
  cursor: pointer;
`;

export default HrAnnouncements;
